/**
 * Status presentation for an existing (non-canceled) subscription. `past_due`
 * gets the "Payment issue" label; the portal button stays enabled regardless
 * (Stripe's portal serves any customer — the past-due bug was gating it on an
 * active status). Pure, so the presentation is unit-tested.
 */
export function subStatusView(status: string): { label: string; pastDue: boolean } {
  const pastDue = status === 'past_due';
  return { label: pastDue ? 'Payment issue' : 'Active', pastDue };
}
